import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import JBImage from 'components/essentials/JBImage';
import { GET_VIDEO_METADATA } from '@/graphql/queries';
import StatusLabel from 'components/consumer/StatusLabel';
import RatioContainer from 'components/consumer/RatioContainer';
import LivestreamPlayIcon from '../LivestreamPlayIcon';
const LivestreamVideoThumbnail = t0 => {
  const $ = _c(46);
  const {
    slug,
    category,
    image,
    isSelected,
    isRecordedLive,
    title,
    videoLength,
    videoType,
    videoId
  } = t0;
  const [duration, updateDuration] = useState(videoLength);
  const [thumbnail, updateThumbnail] = useState(image);
  let t1;
  if ($[0] !== videoId || $[1] !== videoType) {
    t1 = {
      variables: {
        id: videoId,
        type: videoType
      }
    };
    $[0] = videoId;
    $[1] = videoType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    loading,
    data
  } = useSuspenseQuery(GET_VIDEO_METADATA, t1);
  const durationToTime = _temp;
  let t2;
  if ($[3] !== data || $[4] !== loading) {
    t2 = () => {
      if (!loading && data?.getVideoMetadata) {
        if (data.getVideoMetadata?.duration) {
          updateDuration(data.getVideoMetadata.duration);
        }
        if (data.getVideoMetadata?.thumbnails.length > 0) {
          const url = data.getVideoMetadata.thumbnails.length > 3 ? data.getVideoMetadata.thumbnails[3] : data.getVideoMetadata.thumbnails[0];
          updateThumbnail(url);
        }
      }
    };
    $[3] = data;
    $[4] = loading;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = data?.getVideoMetadata;
  let t4;
  if ($[6] !== loading || $[7] !== t3) {
    t4 = [loading, t3];
    $[6] = loading;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t2, t4);
  const t5 = `/videos/${slug}/`;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      scrollToTop: false
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = {
      pathname: t5,
      state: t6
    };
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== thumbnail) {
    t8 = thumbnail && <JBImage src={thumbnail} width={300} className="h-full absolute top-0 left-0 w-full" />;
    $[12] = thumbnail;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isRecordedLive) {
    t9 = isRecordedLive && <StatusLabel className="absolute right-[15px] top-[15px] md:right-5 md:top-5" color="red-dark">RECORDED LIVE</StatusLabel>;
    $[14] = isRecordedLive;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== duration) {
    t10 = !!duration && <div className="text-sm font-bold bottom-5 text-white absolute right-5 [text-shadow:0_0_10px_#000]">{durationToTime(duration)}</div>;
    $[16] = duration;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = !isSelected;
  let t12;
  if ($[18] !== isSelected || $[19] !== t11) {
    t12 = classNames("bottom-0 left-0 absolute right-0 top-0 [transition:opacity_.1s]", {
      "opacity-0": t11,
      "opacity-100": isSelected
    });
    $[18] = isSelected;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="bg-black bottom-0 left-0 opacity-60 absolute right-0 top-0" />;
    t14 = <div className="text-xs font-bold text-white items-center bottom-0 flex justify-center left-0 absolute right-0 top-0">NOW PLAYING</div>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t13 = $[21];
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12) {
    t15 = <div className={t12}>{t13}{t14}</div>;
    $[23] = t12;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = !isSelected;
  let t17;
  if ($[25] !== isSelected || $[26] !== t16) {
    t17 = classNames("items-center bottom-0 flex justify-center left-0 opacity-0 absolute right-0 top-0 [transition:opacity_.15s]", {
      "hover:opacity-100": t16,
      "hover:opacity-0": isSelected
    });
    $[25] = isSelected;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LivestreamPlayIcon />;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t17) {
    t19 = <div className={t17}>{t18}</div>;
    $[29] = t17;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t10 || $[32] !== t15 || $[33] !== t19 || $[34] !== t8 || $[35] !== t9) {
    t20 = <RatioContainer ratio={0.5625}>{t8}{t9}{t10}{t15}{t19}</RatioContainer>;
    $[31] = t10;
    $[32] = t15;
    $[33] = t19;
    $[34] = t8;
    $[35] = t9;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== title) {
    t21 = <div className="text-lg font-bold text-gray mt-4">{title}</div>;
    $[37] = title;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== category) {
    t22 = <div className="text-xs text-gray-light1 mt-1">{category}</div>;
    $[39] = category;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t20 || $[42] !== t21 || $[43] !== t22 || $[44] !== t7) {
    t23 = <Link className="md:pb-4 hover:cursor-pointer" to={t7}>{t20}{t21}{t22}</Link>;
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
    $[44] = t7;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  return t23;
};
LivestreamVideoThumbnail.propTypes = {
  category: PropTypes.string,
  image: PropTypes.string.isRequired,
  isRecordedLive: PropTypes.bool,
  isSelected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  videoLength: PropTypes.string,
  videoType: PropTypes.string,
  videoId: PropTypes.string,
  slug: PropTypes.string
};
export default LivestreamVideoThumbnail;
function _temp(totalSeconds) {
  if (totalSeconds < 86400) {
    const result = new Date(Math.ceil(totalSeconds) * 1000).toISOString().substr(11, 8);
    return result.replace(/^0(?:0:0?)?/, "");
  }
  return totalSeconds;
}